import React from 'react';

import { Box } from '@styleseat/ui';
import {
  HeaderText,
} from '../../../ui';

import { ProAppointmentDetails } from '../../../../api/Providers/Appointments';

type TitleProps = {
  appointment: ProAppointmentDetails;
};

const Title:
React.FC<TitleProps> = ({
  appointment,
}) => (
  <Box
    paddingX={16}
  >
    <HeaderText
      level={1}
      textAlign="center"
      fontSize={24}
      testID="appointment_cancel_search_rank_impact_title"
    >
      {`We're sorry ${appointment.client?.name.split(' ')[0]} wasn't a good match`}
    </HeaderText>
  </Box>
);

export default Title;
